module.exports = __webpack_public_path__ + "static/img/1.3593cd0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/1.png
// module id = 9rl2
// module chunks = 0